import React from "react";
import { EditOutlined } from "@ant-design/icons";
import { Button, List, Space, Tag, Tooltip } from "antd";
import useUpdate from "hooks/useUpdate";
import useDelete from "hooks/useDelete";
import ModalConfirm from "components/ModalConfirm";

const Item = ({ ref2, id, is_active, device, refetch }) => {
  const { is_saving_worker_device, update: updateWorkerDevice } = useUpdate({
    path: `/worker_devices/${id}`,
    onSuccess: refetch,
  });

  const { is_deleting_device, _delete: deleteDevice } = useDelete({
    path: `/worker_devices/${id}`,
    onSuccess: refetch,
  });

  return (
    <List.Item
      className="devices-row"
      style={{ padding: "12px 24px" }}
      split
      actions={[
        <Tooltip
          title={
            device.is_active
              ? null
              : "Urządzenie musi być aktywne, aby przyznać do niego dostęp."
          }
        >
          <Button
            ref={ref2}
            type="primary"
            loading={is_saving_worker_device}
            danger={is_active}
            disabled={!device.is_active}
            onClick={() => updateWorkerDevice({ is_active: !is_active })}
          >
            {is_active ? "Zablokuj" : "Odblokuj"}
          </Button>
        </Tooltip>,
        <ModalConfirm
          button_text="Usuń"
          handleConfirm={deleteDevice}
          loading={is_deleting_device}
          text={
            <p>
              Czy na pewno chcesz usunąć dostęp do urządzenia{" "}
              <strong>
                {device?.name} ({device.imei})
              </strong>
              ?
            </p>
          }
        />,
      ]}
    >
      <Space className="devices-row__content">
        {device?.is_active ? (
          <Tag color="green">Aktywne</Tag>
        ) : (
          <Tag color="red">Nieaktywne</Tag>
        )}
        <a
          href={`/devices/${device?.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Space size="small">
            <span>
              {device?.name || "brak nazwy"} [{device?.imei}]
            </span>
            <EditOutlined />
          </Space>
        </a>
      </Space>
    </List.Item>
  );
};

export default Item;
